import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import 'regenerator-runtime/runtime';
// import Timer from '../buy-v1/timer';
// import { renderBankIframe } from '../buy-v1/aside/checkout';
import Timer from '../buy-v1.1/timer';
import { renderBankIframe } from '../buy-v1.1/aside/checkout';

import { setCookie, getCookie } from '../../helpers/cookie';
import getSberUrl from '../buy-v1.1/helpers/getSberUrl';
import Popup from '../popup';
import QrMobileView from '../buy-v1.1/aside/sbp-pay/qr-mobile-view';
import QrPCView from '../buy-v1.1/aside/sbp-pay/qr-pc-view';

const orderCancelPopup = () => {
  $.magnificPopup.close();
  setTimeout(function () {
    $.magnificPopup.open({
      items: {
        src: '#popup',
      },

      closeOnBgClick: false,
      removalDelay: 250,
      callbacks: {
        beforeOpen() {
          this.st.mainClass = 'mfp-anim';
        },
        open() {
          render(
            <Popup
              type="alert"
              status="success"
              title="Заказ отменен"
              message="Теперь вы можете купить другой билет"
              button="Перейти к афише"
              link="/afisha"
            />,
            $('#popup')[0],
          );
        },

        close() {
          render(<div />, $('#popup')[0]);
        },
      },
    });
  }, 500);
};

const orderCancel = async id => {
  const route = `/local/php_interface/api/v1/buy/cancel/?order_id=${id}`;
  const result = await fetch(route);
  orderCancelPopup();

  setCookie('UNPAID_ORDER', '');
  setCookie('PAYMENT_LINK', '');
  setCookie('ORDER_ID', '');
  setCookie('SBPPAY', '');
  setCookie('PAYMENT_METHOD', '');
  setCookie('PUSHKIN_FIO', '');
};

const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
        return "Android";
    }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "PC";
}

const Unpaid = ({ data, route, paymentLink }) => {
  const orderId = getCookie('ORDER_ID');
  const paymentMethod = getCookie('PAYMENT_METHOD');

  const [isLoading, setIsLoading] = useState(false);
  const [sbpPay, setSbpPay] = useState(false);

  const btnDefaultClasses = 'btn btn--accent btn--outline ';
  const btnClasses = isLoading
    ? btnDefaultClasses + 'btn--loading-red'
    : btnDefaultClasses;
  const {
    movie_name,
    movie_image,
    cinema_name,
    amount,
    places,
    id,
    film_link,
    session_datetime_format,
  } = data;

  const expire =
    window.expire_date != null
      ? window.expire_date
      : Date.now() + 6 * 60 * 1000 + 50000;

  if (!paymentLink) {
    getSberUrl(orderId, paymentMethod);
  }

  const getQrView = (userAgent) => {
    if (sbpPay) {
        if (userAgent === 'PC') {
            return <QrPCView qr={sbpPay.qrImage} orderNumber={sbpPay.order_number} redirectLink={sbpPay.callback_url} />
        } else {
            return <QrMobileView payInfo={sbpPay} os={getMobileOperatingSystem()} orderNumber={sbpPay.order_number} redirectLink={sbpPay.callback_url} />
        }
    } else {
        return false;
    }
  }
  
  const sbpPayView = getQrView(getMobileOperatingSystem());

  useEffect(() => {
    if (getCookie('SBPPAY') && orderId) {

      const data = {
        'order-id': orderId,
        'pay-method': 'sbp',
      };

      const headers = {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
      };

      if (process.env.NODE_ENV !== 'dev') headers.credentials = 'include';

      const route = '/local/php_interface/api/v2/payment/pay/';

      // try to buy a ticket
      fetch(route, headers)
        .then(response => response.json())
        .then(json => {
          if (json.status === 'success') {
            setSbpPay(json.data);
          } else if (json.data.available || json.errors) {
            const err = json.errors;
            returnError([err]);
          }
        })
    }
  }, []);

  return (
    <React.Fragment>
      <Timer expireAtMs={expire} enable={true} static />

      <div className="popup" data-type="unpaid" id="unpaidPopup">
        <div className="order-wrap">
          <div className="order order--coming">
            <div className="order__head">
              <p className="order__number">Неоплаченный заказ</p>
              <button
                className="popup__close"
                type="button"
                onClick={() => $.magnificPopup.close()}
              >
                <svg viewBox="0 0 18 18" width="18" height="18">
                  <path d="M15.5 17.6l-6.5-6.5-6.5 6.5c-.6.6-1.5.6-2.1 0-.6-.6-.6-1.5 0-2.1l6.5-6.5-6.5-6.5c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l6.5 6.5 6.5-6.5c.6-.6 1.5-.6 2.1 0 .6.6.6 1.5 0 2.1l-6.5 6.5 6.5 6.5c.6.6.6 1.5 0 2.1-.3.3-.6.4-1 .4s-.8-.2-1.1-.4z" />
                </svg>
              </button>
            </div>
            <p className="order__details order__descr">
              Вы создали заказ но не оплатили его. Завершите оплату для
              получения электронного билета, либо отмените этот заказ и создайте
              новый.
            </p>
            <div className="order__body">
              {sbpPayView ? (sbpPayView) : (
              <div className="order__poster">
                <div
                  className="poster poster--order"
                  style={{ backgroundImage: `url(${movie_image})` }}
                >
                  <a className="poster__body" href={film_link} />
                </div>
              </div>
              )}
              <div className="order__content">
                <div className="order__block">
                  <h4 className="order__title">{movie_name}</h4>
                  <div className="order__details">
                    <span className="order__date">
                      {session_datetime_format}
                    </span>
                    <span>{cinema_name}</span>
                    <p>{places}</p>
                  </div>
                </div>
                <div className="order__block order__block--buttons">
                  <div className="order__btn-wrap">
                    {!sbpPay && (
                    <button
                      className="btn btn--primary"
                      onClick={() => {
                        // renderBankIframe(getCookie('PAYMENT_LINK'))
                        window.location.href = getCookie('PAYMENT_LINK');
                      }}
                    >
                      Оплатить {amount} руб
                    </button>
                    )}
                    <a
                      className={btnClasses}
                      onClick={() => {
                        orderCancel(id);
                        setIsLoading(true);
                      }}
                    >
                      <span>Отменить</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Unpaid;
